import '../../fonts/fonts.css'
import './CssBaseline.scss'

export const CssBaseline = () => null
